// eslint-disable-next-line no-restricted-imports
import { Menu as MenuBase } from "@base-ui/react/menu";
import classNames from "classnames";
import type {
    MenuGroupLabelProps,
    MenuGroupProps,
    MenuSeparatorProps,
} from "./Menu.types";
import styles from "./MenuPopup.module.scss";

/** A labelled cluster of items; label it with `Menu.GroupLabel`. */
export const MenuGroup = ({ children, className }: MenuGroupProps) => (
    <MenuBase.Group className={classNames(styles.group, className)}>
        {children}
    </MenuBase.Group>
);

/** The group's heading, announced as the group's accessible name. */
export const MenuGroupLabel = ({
    children,
    className,
}: MenuGroupLabelProps) => (
    <MenuBase.GroupLabel className={classNames(styles.groupLabel, className)}>
        {children}
    </MenuBase.GroupLabel>
);

/** A full-width divider between items or groups. */
export const MenuSeparator = ({ className }: MenuSeparatorProps) => (
    <MenuBase.Separator className={classNames(styles.separator, className)} />
);
